import React from 'react';
import { connect } from 'react-redux'
import { Select } from 'antd';
import { executeGetLangs } from '../../simbix/executer'

const Option = Select.Option;

function handleChange(value) {
  console.log(`selected ${value}`);
}


class LangSelector extends React.Component {	
    constructor(props, context) {
        super(props, context)
        this.state = {
            loading: false, 			//Флаг загрузки
            langs: {},                  //Данные для отображения
        }
    }

    componentWillMount() { 
        this.loadLangs();
    }

    loadLangs() {
        this.setState({loading: true})
        return executeGetLangs()
        .then ((response) =>{
            const {data} = response
            this.setState({loading: false, langs: data.langs});
            return Promise.resolve(response)
        })
        .catch(e => { 
            return Promise.reject(e);
        });
    }

    onChangeConcept(e) {
        console.log(`checked = ${e.target.checked}`);
    }

    render() {
        //console.log(this);
        const {loading, langs } = this.state;
        return (
            (loading? <div>Загрузка</div>:
                <Select defaultValue="" style={{ width: 120 }} onChange={handleChange}>
                {langs.map((lang, i) => <Option key={i} value={lang.lang}>{lang.name}</Option>)}
                </Select>
            )
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    const {graph, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        vset
    };
}
export default connect(mapStateToProps)(LangSelector);